import { Box } from "@material-ui/core";
import { ConfirmDialog } from "components/dialog";
import Loading from "components/loading";
import { formatMessage } from "lib/globalize-util";
import React from "react";
import { useUploader } from "./context-api/hooks/use-uploader";
import { SummarizeChanges } from "./summarize-changes";

export const DialogDoubleCheckChanges = (): JSX.Element => {
    const {
        isOpenDialogToConfirmChanges,
        handleConfirmChanges,
        handleCancelChanges,
        isUpdating,
        wasUpdated,
        columnsToCreate,
        columnsToUpdate,
        columnsHeadersMap,
        doorsForDisableOrEnable,
        doorsForDisableWithUnits,
        doorsForEnableWithUnits,
        handleClickOk,
    } = useUploader();

    const handleConfirm = () => {
        if (wasUpdated) {
            handleClickOk?.();
        } else {
            handleConfirmChanges?.();
        }
    };

    const mapColumnsToHeaderNames = (fields: string[]) =>
        (fields || []).map((field) => columnsHeadersMap?.get(field) || field);

    return (
        <ConfirmDialog
            title={wasUpdated ? formatMessage("Upload complete!") : formatMessage("Confirm your changes")}
            open={isOpenDialogToConfirmChanges}
            onConfirm={handleConfirm}
            onCancel={handleCancelChanges}
            hideCancelButton={wasUpdated}
            autoScrollBodyContent
            contentStyle={{ maxWidth: "600px" }}
            cancelLabel={formatMessage("No, cancel upload")}
            confirmLabel={wasUpdated ? formatMessage("Done") : formatMessage("Yes, make these changes")}
        >
            <Box paddingY={2}>
                {isUpdating ? (
                    <Loading />
                ) : (
                    <SummarizeChanges
                        wasUpdated={wasUpdated}
                        columnsToCreate={mapColumnsToHeaderNames(columnsToCreate)}
                        columnsToUpdate={mapColumnsToHeaderNames(columnsToUpdate)}
                        doorsForDisableOrEnable={doorsForDisableOrEnable}
                        doorsForDisableWithUnits={doorsForDisableWithUnits}
                        doorsForEnableWithUnits={doorsForEnableWithUnits}
                    />
                )}
            </Box>
        </ConfirmDialog>
    );
};
